<template>
    <div class="copy" @click="onCopy" style="cursor: pointer">
        <slot>
            <Icon name="el-icon-DocumentCopy" size="16" />
        </slot>
    </div>
</template>

<script setup lang="ts">
import { ElNotification } from 'element-plus'
const props = defineProps({
    text: {
        type: String,
        default: '',
    },
})

/**
 * 复制信息
 */
const onCopy = async (text: any) => {
    try {
        await navigator.clipboard.writeText(props.text)
        ElNotification.success('复制成功')
    } catch (err) {
        console.error('复制到剪贴板失败:', err)
    }
}
</script>

<style lang="scss" scoped></style>
